import { BehaviorSubject } from 'rxjs';

export class AssetTreeUiService {
  private readonly scrolled$$ = new BehaviorSubject<boolean>(false);

  readonly scrolled$ = this.scrolled$$.asObservable();

  setScrolled(value: boolean) {
    this.scrolled$$.next(value);
  }
}
